"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.active.help': 'Activar este conocimiento para su uso',
};
